/**
 * isServer
 * @description returns true if current runtime is on the server
 */
export var isServer = function isServer() {
  return typeof window === 'undefined';
};

/**
 * isClient
 * @description returns true if current runtime is on the server
 */
export var isClient = function isClient() {
  return typeof window !== 'undefined';
};